import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MediaFolder, MediaTree, FolderDialogData, ConfirmDialogData, RenameFolderDialogData, FolderMoveResultData, FolderNode, SelectFolderData } from 'src/app/utils/common-classes';
import { MatMenuTrigger } from '@angular/material';
import { CreateFolderDialogComponent } from '../create-folder-dialog/create-folder-dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { RenameFolderDialogComponent } from '../rename-folder-dialog/rename-folder-dialog.component';
import { FolderDataSource } from 'src/app/utils/dynamic-tree-classes';
import { MoveFolderDialogComponent } from '../move-folder-dialog/move-folder-dialog.component';
export class FolderTreeComponent {
    constructor(treeService, utils, dialog, folderService) {
        this.treeService = treeService;
        this.utils = utils;
        this.dialog = dialog;
        this.folderService = folderService;
        this.selectFolder = new EventEmitter();
        this.contextMenuPosition = { x: '0px', y: '0px' };
    }
    onContextMenu(event, node) {
        event.preventDefault();
        this.contextMenuPosition.x = event.clientX + 'px';
        this.contextMenuPosition.y = event.clientY + 'px';
        if (node) {
            this.folderMenuTrigger.menuData = { 'node': node };
            this.folderMenuTrigger.menu.focusFirstItem('mouse');
            this.folderMenuTrigger.openMenu();
        }
        else {
            this.treeMenuTrigger.menu.focusFirstItem('mouse');
            this.treeMenuTrigger.openMenu();
        }
    }
    ngOnInit() {
        this.treeControl = new FlatTreeControl(this.getLevel, this.isExpandable);
        this.dataSource = new FolderDataSource(this.treeControl, this.mediaTree.mediaTreeId, this.utils, this.folderService);
    }
    getLevel(node) {
        return node.level;
    }
    ;
    isExpandable(node) {
        return node.expandable;
    }
    ;
    hasChild(_, _nodeData) {
        return _nodeData.expandable;
    }
    ;
    folderClick(node) {
        let _self = this;
        let data = new SelectFolderData();
        data.node = node;
        data.tree = _self.mediaTree;
        _self.selectFolder.emit(data);
    }
    folderSelected(node) {
        let _self = this;
        let folder = _self.dataSource.getFolder(node.mediaFolderId);
        this.selectedFolder = folder;
    }
    createFolder(node, mediaTree) {
        let _self = this;
        let data = { node: node, mediaTree: mediaTree };
        let dialogRef = _self.dialog.open(CreateFolderDialogComponent, { width: "400px", data: data, disableClose: true });
        dialogRef.afterClosed().subscribe((newFolder) => {
            if (newFolder) {
                if (!node || _self.treeControl.isExpanded(node)) {
                    _self.dataSource.addFolder(newFolder, node);
                }
                else {
                    _self.treeControl.expand(node);
                }
            }
        });
    }
    deleteFolder(node) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            let title = yield _self.utils.translateKey("dialog.confirm.title.delete-folder");
            let message = yield _self.utils.translateKeyWithData("dialog.confirm.message.delete-folder", { folderName: node.getName(_self.utils.getLanguage()) });
            let data = { title: title, message: message };
            let dialogRef = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
            dialogRef.afterClosed().subscribe((del) => {
                if (del) {
                    _self.utils.showShortLoader;
                    _self.folderService.deleteFolder(node.mediaFolderId).then(() => {
                        _self.dataSource.deleteFolder(node);
                    }).catch((err) => {
                        return _self.utils.getErrorShowToast(err);
                    }).finally(() => {
                        _self.utils.hideShortLoader();
                    });
                }
            });
        });
    }
    renameFolder(node) {
        let _self = this;
        let data = { node: node };
        let dialogRef = _self.dialog.open(RenameFolderDialogComponent, { width: "600px", data: data, disableClose: true, panelClass: "no-padding-dialog-container", autoFocus: false });
        dialogRef.afterClosed().subscribe((renamedFolder) => {
            if (renamedFolder) {
                _self.dataSource.updateFolder(renamedFolder);
            }
        });
    }
    moveFolder(node, mediaTree) {
        let _self = this;
        let data = { node: node, mediaTree: mediaTree };
        let dialogRef = _self.dialog.open(MoveFolderDialogComponent, { width: "50%", data: data, minWidth: "500px", height: "600px", disableClose: true });
        dialogRef.afterClosed().subscribe((folderMoveResultData) => {
            if (folderMoveResultData) {
                //elimino il nodo attuale
                _self.dataSource.deleteFolder(node);
                //aggiungo all' albero
                if (folderMoveResultData.parentFolder) {
                    //nuova cartella padre se non null cerco se il padre è presente
                    let parentFolder = _self.dataSource.getFolder(folderMoveResultData.parentFolder.mediaFolderId);
                    if (parentFolder) {
                        //se il padre è attualmente presente nell' albero aggiungo la cartella
                        if (_self.treeControl.isExpanded(parentFolder)) {
                            //se il padre è già aperto aggiungo
                            _self.dataSource.addFolder(folderMoveResultData.folder, parentFolder);
                        }
                        else {
                            //se il padre è chiuso lo apro
                            _self.treeControl.expand(parentFolder);
                        }
                    }
                }
                else {
                    //nuova cartella padre se null aggiungo alla root
                    _self.dataSource.addFolder(folderMoveResultData.folder, null);
                }
            }
        });
    }
}
